(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "69254eba791786dab502b297";
              window.beaePageSetting.pageTitle = "annoucement"; 
              window.beaePageSetting.pageType = "section";

          let js_LVI8UVPO = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-viaxpy61section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-viaxpy61',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-viaxpy61');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-viaxpy61: ', ex)
      };
    

      try {
        let argid = 'beae-viaxpy61section-developer',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-viaxpy61',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-viaxpy61');
        args.el = args.els[0];
        ((data
) => { document.getElementById("close").addEventListener("click", function () {
  document.getElementById("announce").style.display = "none";
}); })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-viaxpy61: ', ex)
      };
    

      try {
        let argid = 'beae-ovpxgmkbblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ovpxgmkb',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ovpxgmkb');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ovpxgmkb: ', ex)
      };
    }; if (window.BEAEBASE) {js_LVI8UVPO()} else {window.BEAEPAGEJS.push(js_LVI8UVPO)} })(); 